import React, {useState, useEffect} from 'react'
import { useQuery } from "@apollo/client"
import ReactTooltip from 'react-tooltip'
import Announce from '../Announce/Announce'
import Spinner from "../Spinner/Spinner"
import Counter from "./Counter"
import LinkMore from "./LinkMore"
import Tooltip from '../Tooltip/Tooltip'
import { GET_ANNOUNCES } from "../../../graphql/index"
import { serialize } from "../../../utils"
import {AUTH_NOT_AUTHORIZED, INITIAL_FILTER} from "../../../constant"
import css from './Announces.module.scss'
import lCss from '../../Layout/Layout.module.scss'
import {fetchLogout} from "../../../api/api";

export default function Announces ({variables = INITIAL_FILTER, limit = 10, query = GET_ANNOUNCES, title = 'Все события', buttonTitle = 'Показать ещё', buttonMore = false, counter = false, linkMore = false, tooltip = null, dataTarget = '', isLoading = () => {}}) {
	const [pager, setPager] =  useState(true)
	const {loading, data, fetchMore} = useQuery(query, {variables: serialize(variables)})
	const count = data?.announces.length || 0

	const loadMore = () =>{
		if (typeof buttonMore ==='function') {
			buttonMore()
		} else {
			fetchMore({
				variables: {
					start: data?.announces.length
				},
				updateQuery: (prev, {fetchMoreResult}) => {
					if (!fetchMoreResult || !fetchMoreResult?.announces?.length) {
						setPager(false)
						return prev
					}
					return Object.assign({}, prev, {
						announces: [...prev.announces, ...fetchMoreResult.announces]
					});
				}
			})
		}
	}

	useEffect( () => {
		setPager(true)
	},[variables])

	useEffect(() => {
		isLoading(loading)
	},[loading])


	useEffect(() => {
		if(data?.auth === AUTH_NOT_AUTHORIZED){
			fetchLogout();
		}
	},[data?.auth]);


	return (
		<div className={css.announces} data-target={dataTarget}>
			{counter ? <Counter variables={variables}/> : null}
			<div className={css.title}>
				{title}
				{tooltip ? <Tooltip text={tooltip}/> : null}
			</div>
			<div className={css.list}>
				{loading ? <Spinner/> : null}
				{data?.announces?.map((item, i) => {
					return <Announce data={item} dataTarget={dataTarget} key={i}/>
				})}
				{(!data?.announces?.length && !loading) ? <div className={css.empty}>Ничего не найдено</div> : null}
			</div>
			{(buttonMore && pager && count && Math.floor(count/((Math.floor(count/limit) || 1) * limit))) ? <div className={css.footer}><button className={lCss.button} onClick={loadMore}>{buttonTitle}</button></div> : null}
			{linkMore ? <LinkMore variables={variables} limit={limit}/> : null}
		</div>
	);
}